import React, { useState } from 'react';
import Logo from '../Logo';

const Header = ({ onNavigateLogin }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="bg-white border-b border-gray-100 sticky top-0 z-50">
        <div className="w-full px-4 py-4 flex items-center justify-between">
          <a href="/" className="ml-4">
            <Logo width="208" height="32" textFill="black" />
          </a>
          <div className="hidden lg:flex items-center gap-5 mr-4">
            <button onClick={() => scrollTo('features')} className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap">
              Platform
            </button>
            <button onClick={() => scrollTo('demos')} className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap">
              Demos
            </button>
            <button onClick={() => scrollTo('pricing')} className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap">
              Pricing
            </button>
            <a href="/pricing-calculator" className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap">
              Cost Calculator
            </a>
            <a href="https://developers.remote-assistant.io" target="_blank" rel="noopener noreferrer" className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors flex items-center gap-1 whitespace-nowrap">
              API Docs
              <i className="fa fa-external-link text-[9px] text-gray-400"></i>
            </a>
            <button onClick={() => scrollTo('contact')} className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap">
              Contact
            </button>
            <a href="https://blog.remote-assistant.ai" target="_blank" rel="noopener noreferrer" className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors flex items-center gap-1 whitespace-nowrap">
              Blog
              <i className="fa fa-external-link text-[9px] text-gray-400"></i>
            </a>
            <button
              onClick={() => onNavigateLogin(false)}
              className="text-gray-700 text-[13px] font-medium hover:text-[#055EFD] transition-colors whitespace-nowrap"
            >
              Login
            </button>
            <button
              onClick={() => onNavigateLogin(true)}
              className="px-5 py-2 bg-[#055EFD] rounded text-white text-[13px] font-bold hover:bg-[#0449d4] transition-colors whitespace-nowrap"
            >
              Get Started
            </button>
          </div>
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="lg:hidden text-gray-700 hover:text-[#055EFD] mr-4"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {mobileMenuOpen && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black/20 z-40 lg:hidden" onClick={() => setMobileMenuOpen(false)} />

          {/* Dropdown panel */}
          <div className="fixed top-0 left-0 right-0 z-50 lg:hidden bg-white shadow-xl border-b border-gray-200 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b border-gray-100">
              <a href="/">
                <Logo width="208" height="32" textFill="black" />
              </a>
              <button
                onClick={() => setMobileMenuOpen(false)}
                className="text-gray-700 hover:text-[#055EFD]"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="flex flex-col gap-1 p-4">
              {[
                { label: 'Platform', action: () => scrollTo('features') },
                { label: 'Demos', action: () => scrollTo('demos') },
                { label: 'Pricing', action: () => scrollTo('pricing') },
                { label: 'Cost Calculator', action: () => { setMobileMenuOpen(false); window.location.href = '/pricing-calculator'; } },
                { label: 'Contact', action: () => scrollTo('contact') },
              ].map(item => (
                <button key={item.label} onClick={item.action}
                  className="text-left text-gray-700 text-base font-medium hover:text-[#055EFD] hover:bg-gray-50 px-3 py-2.5 rounded-lg transition-colors">
                  {item.label}
                </button>
              ))}

              <div className="border-t border-gray-100 my-2" />

              <a href="https://developers.remote-assistant.io" target="_blank" rel="noopener noreferrer"
                className="text-gray-700 text-base font-medium hover:text-[#055EFD] hover:bg-gray-50 px-3 py-2.5 rounded-lg transition-colors flex items-center gap-2">
                API Docs <i className="fa fa-external-link text-[10px] text-gray-400"></i>
              </a>
              <a href="https://blog.remote-assistant.ai" target="_blank" rel="noopener noreferrer"
                className="text-gray-700 text-base font-medium hover:text-[#055EFD] hover:bg-gray-50 px-3 py-2.5 rounded-lg transition-colors flex items-center gap-2">
                Blog <i className="fa fa-external-link text-[10px] text-gray-400"></i>
              </a>
              <a href="https://remote-assistant.ai" target="_blank" rel="noopener noreferrer"
                className="text-gray-700 text-base font-medium hover:text-[#055EFD] hover:bg-gray-50 px-3 py-2.5 rounded-lg transition-colors flex items-center gap-2">
                For Businesses <i className="fa fa-external-link text-[10px] text-gray-400"></i>
              </a>

              <div className="border-t border-gray-100 my-2" />

              <div className="flex gap-3 px-3 pt-1 pb-2">
                <button
                  onClick={() => { setMobileMenuOpen(false); onNavigateLogin(false); }}
                  className="flex-1 py-2.5 border border-gray-300 rounded-lg text-gray-700 text-sm font-semibold hover:border-[#055EFD] hover:text-[#055EFD] transition-colors"
                >
                  Login
                </button>
                <button
                  onClick={() => { setMobileMenuOpen(false); onNavigateLogin(true); }}
                  className="flex-1 py-2.5 bg-[#055EFD] rounded-lg text-white text-sm font-bold hover:bg-[#0449d4] transition-colors"
                >
                  Get Started
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Header;
